/**
 * Utility functions for avatar generation and handling
 */

/**
 * Generates a fallback avatar URL for a given name using UI Avatars service
 * @param name The display name to use for the avatar
 * @returns A URL string for the avatar image
 */
export const generateFallbackAvatar = (name: string): string => {
  // Encode the name for use in a URL
  const encodedName = encodeURIComponent(name);
  
  // Generate a random color based on the name
  const getColorFromName = (name: string) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = Math.abs(hash).toString(16).substring(0, 6);
    return color.padStart(6, '0');
  };
  
  const backgroundColor = getColorFromName(name);
  
  // Return the UI Avatars URL with appropriate parameters
  return `https://ui-avatars.com/api/?name=${encodedName}&background=${backgroundColor}&color=fff`;
};

/**
 * Extracts initials from a name (up to 2 characters)
 * @param name The display name to extract initials from
 * @returns A string with the initials (1-2 characters)
 */
export const getInitials = (name: string): string => {
  if (!name) return '?';
  
  const parts = name.trim().split(/\s+/);
  
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}; 